export const 당진공장 = {
  "Roll Shop": ["Roll Shop"],
  가열로: ["가열로", "가열로(수처리)"],
  공통: ["공통"],
  기계: ["Maintenance Room(공무작업장)", "열처리동 샵장", "Shear 샵장"],
  박물GAS: ["시편장", "Plasma #1", "Plasma #2", "박물연마", "Knife 연마"],
  소재절단: ["소재절단(수동)", "소재절단(자동)", "소재절단(정보)"],
  소재크레인: ["소재크레인", "소재가열"],
  스카핑: ["스카핑", "스카핑"],
  시험실: ["시험실(시험)", "시험실(가공)", "시험실(화학)", "시험실(화학)"],
  열처리: ["열처리로"],
  재공크레인: ["재공크레인"],
  전기: ["공통"],
  전단: ["C/S", "DSTS", "DS", "마킹 #1", "마킹 #2"],
  중앙창고: ["공통"],
  최종: ["최종검사 #1", "최종검사 #2"],
  출하관리: ["출하관리"],
  출하크레인: ["출하크레인"],
  특수강: ["특수강 지원", "탄소강 지원(협폭단척, 표면연마)"],
  후물GAS: ["후물연마", "후물연마(최종)", "후물시편", "열처리 절단(수동)", "열처리 절단(자동)", "자동절단(CNC #3)", "수동절단", "Press Leveller", "Heat Treatment Leveller", "Cold Leveller"],
};

export const 인천공장 = {
  "100톤제강": ["용해", "LF", "연주", "기중기", "기중기(고철장)", "기술반", "부재료", "기계", "전기", "검사"],
  "120톤제강": ["용해", "LF", "연주", "기중기", "기중기(고철장)", "기술반", "부재료", "검사", "기계", "전기"],
  "1호압연": ["중앙조작실", "정정", "기중기", "기계", "전기", "인장실", "생산관제", "출하기중기"],
  "2호압연": ["중앙조작실", "정정", "기중기", "기계", "전기", "인장실", "출하기중기"],
  롤샵: ["현장", "CNC", "용접"],
  사내물류: ["사내물류"],
  산소공장: ["기계"],
  상차원: ["1호 상차", "2호 상차", "제품창고/야적장"],
  수처리: ["기계"],
  안전환경팀: ["안전환경"],
  자재창고: ["자재창고"],
  출하: ["검수", "자재창고"],
  출하관제실: ["출하관제", "1호 출하", "2호 출하"],
};

export const 포항공장 = {
  제강: [
    "집진기",
    "고철절단",
    "포트보수",
    "중장비(포크레인 및 포트캐리어)",
    "청소차량(먼지)",
    "중장비(정비)",
    "고철 크레인운반",
    "고철검수(GS절단)",
    "제강 크레인운반",
    "전기로",
    "부원료",
    "L/F(정련로)",
    "연주",
    "축로반",
    "S/N 반",
    "브롬장 크레인",
    "제강공무",
    "제강전기",
    "제강검사(스카킹)",
  ],
  형강: ["가열로", "압연", "롤샵(해체조립)", "롤샵(베어링)", "롤샵(가공)", "롤샵(수리보수)", "정정", "R/S 롤조립", "검사", "제품출하", "형강공무", "전기점검", "밴드쇼"],
  후판: ["1후판출하", "2후판출하", "중앙시험실(물리)", "중앙시험실(화학)", "영선", "GFRP", "BH"],
  CS: ["가열압연", "D-KOIL", "정정", "롤샵", "전기", "공무", "제품출하", "제품검사"],
  연구소: ["실험1동", "실험2동", "연구동"],
  부대: ["부대공무", "부대전기"],
  기타: ["안전환경"],
};
